import { addDoc, collection } from "firebase/firestore"
import { db } from "../config/firebase";
import { sessionId } from "../conversation";
import { metarun_users } from "../config/runners";


const messageCollectionRef = collection(db, "messages");

const addMessage = async (userId, userEmail, role, timestamp, messageContent, processedMessageContent) => {
    try {
        await addDoc(messageCollectionRef, {
            sessionId,
            userId,
            userEmail,
            role,
            timestamp,
            messageContent,
            processedMessageContent
        });
    } catch (error) {
        console.error('addMessage Error', error);
    }
}

// test imports metarun users
function addMetaRunners() {
    const usersCollectionRef = collection(db, "users");
    metarun_users.forEach(async (runner) => {
        try {
            console.log('add runner from metarun...');
            await addDoc(usersCollectionRef, runner);
        } catch (error) {
            console.error('add user Error', error);
        }
    });
}
export { addMessage, addMetaRunners };


// WEBPACK FOOTER //
// ./src/api/firebaseStore.js